import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-module-decorators';
import FileUpload from '@/components/FileUpload/index.vue';
import Sortable from 'sortablejs';
import { updateProductImages, deleteProductImages } from '@/api/products';
import HelpText from '@/components/HelpText/index.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.rules = {};
    this.coverImageId = 0;
    this.sortable = null;
  }
  fileUploaded(file) {
    /* eslint-disable */
    this.formData.productsImage.push({
      isCover: false,
      image: file.response,
      priority: this.formData.productsImage.length + 1
    });
    // check if only one image then make it cover
    if (this.formData.productsImage.length === 1) {
      this.formData.productsImage[0].isCover = true;
    }
    /* eslint-enable */
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  activated() {
    this.$nextTick(() => {
      this.setSort();
    });
  }
  handleProductTypeChange() {
    this.$emit('updated', this.formData);
  }
  async saveForm() {
    this.loading = true;
    try {
      await updateProductImages(this.formData.id, {
        productsImage: this.formData.productsImage
      });
      this.$notify({
        title: 'Success',
        message: 'Images saved',
        type: 'success',
        duration: 2000
      });
      this.$emit('updated', this.formData);
    } catch (err) {
      this.$notify.error(err.toString());
    } finally {
      this.loading = false;
    }
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  handleCoverChange(rowIndex) {
    if (rowIndex in this.formData.productsImage) {
      // disabled active
      this.formData.productsImage.forEach((image, index) => {
        if (rowIndex !== index) {
          image.isCover = false;
        }
      });
      // enable this
      this.formData.productsImage[rowIndex].isCover = true;
      this.handleProductTypeChange();
    }
  }
  async handleDelete(image, index = -1) {
    if (image) {
      try {
        await this.$confirm(this.$tc('table.deleteConfirmation', undefined, {
          name: image.id
        }), this.$tc('table.delete'), {
          confirmButtonText: this.$tc('table.delete'),
          confirmButtonClass: 'el-button--danger',
          cancelButtonText: 'Cancel',
          type: 'error'
        });
        if (image.id) {
          await deleteProductImages(image.id);
        }
        // remove this from the list
        if (index > -1) {
          this.formData.productsImage.splice(index, 1);
        }
        this.reCalculatePriority();
        this.handleProductTypeChange();
      } catch (error) {
        this.$message({
          type: 'info',
          message: this.$tc('table.deleteCanceled')
        });
      }
    }
  }
  setSort() {
    // tslint:disable-next-line no-undef: "error"
    const el = this.$refs.dragTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
    this.sortable = Sortable.create(el, {
      ghostClass: 'sortable-ghost',
      setData: function (dataTransfer) {
        // to avoid Firefox bug
        // Detail see : https://github.com/RubaXa/Sortable/issues/1012
        dataTransfer.setData('Text', '');
      },
      onEnd: evt => {
        const targetRow = this.formData.productsImage.splice(evt.oldIndex, 1)[0];
        this.formData.productsImage.splice(evt.newIndex, 0, targetRow);
        this.reCalculatePriority();
        this.handleProductTypeChange();
      }
    });
  }
  reCalculatePriority() {
    this.formData.productsImage.forEach((image, index) => {
      image.priority = index + 1;
    });
  }
};
__decorate([Prop({
  default: {}
})], default_1.prototype, "formData", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'ProductImagesTab',
  components: {
    FileUpload,
    HelpText
  }
})], default_1);
export default default_1;